import {
  BIKE_FACILITY_TYPE,
  BIKE_FACILITY_TYPE_VALUES,
  BUFFER_BIKE_SIDEWALK,
  BUFFER_BIKE_SIDEWALK_VALUES,
  BUFFER_BIKE_TRAVEL_LANE,
  BUFFER_BIKE_TRAVEL_LANE_VALUES,
  CURBSIDE_MANAGEMENT,
  CURBSIDE_MANAGEMENT_VALUES,
  LATERAL_DISTANCE_BETWEEN_MARKINGS_AND_EDGE_OF_SIDEWALK_OR_PARKED_CARS,
  LATERAL_DISTANCE_BETWEEN_MARKINGS_AND_EDGE_OF_SIDEWALK_OR_PARKED_CARS_VALUES,
  MID_BLOCK_CONFLICTS,
  MID_BLOCK_CONFLICTS_VALUES,
  SHARED_LANE_PAVEMENT_MARKINGS_PRESENT,
  SHARED_LANE_PAVEMENT_MARKINGS_PRESENT_VALUES,
  SIDEWALK_WIDTH,
  SIDEWALK_WIDTH_VALUES,
  SPECIAL_CONSIDERATIONS,
  SPECIAL_CONSIDERATIONS_VALUES,
  STREET_BUFFER_WIDTH,
  STREET_BUFFER_WIDTH_VALUES,
  USABLE_BIKEWAY_WIDTH,
  USABLE_BIKEWAY_WIDTH_VALUES
} from '../constants/bike'

export const bicycleConfig = [
  {
    name: 'Bike Facility Type',
    id: BIKE_FACILITY_TYPE,
    inputType: 'dropDown',
    required: true,
    inputValues: BIKE_FACILITY_TYPE_VALUES,
    scores: null,
    notes:
      'This input is used to determine the criteria for assessing the bicyclists’ experience. “No dedicated bikeway” includes shared lane pavement markings, advisory bike lanes, and rural paved shoulders. “One-way” facilities include bikeways on both sides of a two-way road that only allow movement in a single direction. “Two-way” refers to bikeways that allow movement in both directions on one side of the road.” An “in-roadway” bikeway is at the same height as the street. A “raised” bikeway is elevated above the height of the street or at the same height as the sidewalk.'
  },
  {
    name: 'Buffer Width',
    id: STREET_BUFFER_WIDTH,
    inputType: 'dropDown',
    required: true,
    inputValues: STREET_BUFFER_WIDTH_VALUES,
    notes:
      'The lateral distance between the edge of the bikeway and the travel lane. “Barrier” refers to a physical separation, such as raised medians.'
  },
  {
    name: 'Buffer Type',
    id: BUFFER_BIKE_TRAVEL_LANE,
    inputType: 'checkBox',
    required: true,
    inputValues: BUFFER_BIKE_TRAVEL_LANE_VALUES,

    notes: 'Select all that apply.'
  },
  {
    name: 'Usable Bikeway Width',
    id: USABLE_BIKEWAY_WIDTH,
    inputType: 'dropDown',
    required: true,
    inputValues: USABLE_BIKEWAY_WIDTH_VALUES,

    notes:
      'Choose the usable width of the bike facility. For two-way facilities, pick the combined width of both directions of travel.'
  },
  {
    name: 'Curbside Management',
    id: CURBSIDE_MANAGEMENT,
    inputType: 'dropDown',
    required: true,
    inputValues: CURBSIDE_MANAGEMENT_VALUES,

    notes:
      'Does roadway design accommodate vehicle loading, or do these activities interfere with bicyclists?'
  },
  {
    name: 'Buffer Between Bikeway and Sidewalk',
    id: BUFFER_BIKE_SIDEWALK,
    inputType: 'checkBox',
    required: true,
    inputValues: BUFFER_BIKE_SIDEWALK_VALUES,

    notes: 'Select all that apply.'
  },
  {
    name: 'Sidewalk Width',
    id: SIDEWALK_WIDTH,
    inputType: 'dropDown',
    required: true,
    inputValues: SIDEWALK_WIDTH_VALUES,

    notes: 'Choose an option from the drop-down menu.'
  },
  {
    name: 'Shared Lane Pavement Markings Present',
    id: SHARED_LANE_PAVEMENT_MARKINGS_PRESENT,
    inputType: 'dropDown',
    required: true,
    inputValues: SHARED_LANE_PAVEMENT_MARKINGS_PRESENT_VALUES,

    notes:
      'Indicate the presence of shared lane markings, or “sharrows,” and the distance at which they’re located.'
  },
  {
    name: 'Lateral Distance Between Markings and Edge of Curb or Buffer',
    id: LATERAL_DISTANCE_BETWEEN_MARKINGS_AND_EDGE_OF_SIDEWALK_OR_PARKED_CARS,
    inputType: 'dropDown',
    required: true,
    inputValues:
      LATERAL_DISTANCE_BETWEEN_MARKINGS_AND_EDGE_OF_SIDEWALK_OR_PARKED_CARS_VALUES,
    scores: [4, 1, 2],
    notes:
      'Choose the lateral distance between shared lane pavement markings, if any, and the edge of the travel lane.'
  },
  {
    name: 'Midblock Conflicts',
    id: MID_BLOCK_CONFLICTS,
    inputType: 'dropDown',
    required: true,
    inputValues: MID_BLOCK_CONFLICTS_VALUES,
    scores: [4, 1, 2],
    notes:
      'Conflicts include driveways, transit stops, or midblock crosswalks. Volume refers to the frequency at which these features may conflict with bikes in the road, e.g. the volume of vehicles entering/exiting driveways. For dedicated bikeways, these conflicts can be addressed through raised bike crossings.'
  },
  {
    name: 'Special Considerations',
    id: SPECIAL_CONSIDERATIONS,
    inputType: 'checkBox',
    required: true,
    inputValues: SPECIAL_CONSIDERATIONS_VALUES,
    scores: [],
    notes: 'Leave unchecked if not applicable'
  },
  {
    name: 'Roadway Speed (MPH)',
    id: 'prevailing_posted_speed',
    inputType: 'number',
    required: true,
    notes: 'Value populated in project setup on previous page.',
    scores: [],
    autoPopulated: true
  },
  {
    name: 'Travel Lanes',
    id: 'travel_lanes',
    inputType: 'number',
    required: true,
    notes: 'Value populated in project setup on previous page.',
    scores: [],
    autoPopulated: true
  },
  {
    name: 'Bicycle Tier',
    id: 'tier',
    inputType: 'string',
    required: true,
    notes: 'Value populated in project setup on previous page.',
    scores: null,
    autoPopulated: true
  },
  {
    name: 'Land Use Context',
    id: 'land_use_context',
    inputType: 'string',
    required: true,
    notes: 'Value populated in project setup on previous page.',
    scores: null,
    autoPopulated: true
  }
]
